import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PageWrapper from "./PageWrapper";
import { useQuizContext } from "./QuizContext";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import Alert from "../../assets/images/alert.png";
import "./SignupCommon.css";

const SignupPage5: React.FC = () => {
  const [dob, setDob] = useState<string>("");
  const [isValidAge, setIsValidAge] = useState<boolean>(true);
  const [isInvalidDate, setIsInvalidDate] = useState<boolean>(false); // Track if the date is invalid
  const { setAnswer } = useQuizContext();
  const navigate = useNavigate();

  useEffect(() => {
    const step1Completed = localStorage.getItem("step-1-completed");
    if (step1Completed) {
      navigate("/getting-started/step-2",{ replace: true });
    } else {
      navigate("/getting-started/step-1",{ replace: true });
    }
  }, []);
  const calculateAge = (dob: string) => {
    const [month, day, year] = dob.split("/").map(Number); 
    const birthDate = new Date(year, month - 1, day);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const isValidDate = (dob: string) => {
    const [month, day, year] = dob.split("/").map(Number); // MM/DD/YYYY format

    // Check if the month, day, or year are invalid
    if (
      month < 1 ||
      month > 12 ||
      day < 1 ||
      day > 31 ||
      year < 1900 ||
      year > new Date().getFullYear()
    ) {
      setIsInvalidDate(true);
      return false;
    }

    // Create a date object to check for valid day/month combinations
    const birthDate = new Date(year, month - 1, day);

    // Check if the date is valid
    if (
      birthDate.getDate() !== day ||
      birthDate.getMonth() !== month - 1 ||
      birthDate.getFullYear() !== year
    ) {
      setIsInvalidDate(true);
      return false;
    }

    // Check if the date is in the future
    const today = new Date();
    if (birthDate > today) {
      setIsInvalidDate(true);
      return false;
    }

    setIsInvalidDate(false);
    return true;
  };

  useEffect(() => {
    const savedDob = localStorage.getItem("dob");
    const storedUUID = localStorage.getItem("uuid");
    if (savedDob) {
      const parsedDob = JSON.parse(savedDob);
      setDob(parsedDob.value);
    }
  }, []);

  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value.replace(/[^\d]/g, "");

    if (value.length > 8) value = value.slice(0, 8); 

    let formattedValue = value;
    if (value.length >= 2)
      formattedValue = `${value.slice(0, 2)}/${value.slice(2)}`;
    if (value.length >= 4)
      formattedValue = `${value.slice(0, 2)}/${value.slice(2, 4)}/${value.slice(
        4
      )}`;

    setDob(formattedValue);

    if (formattedValue.length === 10) {
      // Validate the date before calculating age
      const isDateValid = isValidDate(formattedValue);
      if (isDateValid) {
        const age = calculateAge(formattedValue);
        setIsValidAge(age >= 18 && age <= 74);
      } else {
        setIsValidAge(false);
      }
    }else{
      setIsValidAge(true);
    }
  };

  const handleNext = () => {
    if (dob) {
      // Store the date in MM/DD/YYYY format in local storage
      localStorage.setItem(
        "dob",
        JSON.stringify({ key: "dob", value: dob, id: 18026057 })
      );

      const [month, day, year] = dob.split("/");
      const formattedDobForApi = `${day}/${month}/${year}`;

      setAnswer("dob", formattedDobForApi, "18026057");
      if(isValidAge && !isInvalidDate){
        navigate("/getting-started/step-3");
      }else{
        navigate("/getting-started/invalid-age") 
      }
    }
    localStorage.setItem("step-2-completed", "true");
  };

  const step = 2;
  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <ProgressBar progress={30} step={step} />
        <div className="signup-content">
          <p className="signup-intro" style={{ marginBottom: "0px" }}>
            What is your date of birth?
          </p>
          <p className="sub-heading-question">
            This information helps your doctor determine if you're eligible for
            treatment
          </p>
          <div className="dob-input-container" style={{ marginBottom: "20px" }}>
            <input
              type="text"
              placeholder="MM/DD/YYYY" 
              value={dob}
              onChange={handleDateChange}
              maxLength={10}
              className={`input-fields ${isInvalidDate || (!isValidAge && dob.length === 10) ? "invalid-input" : ""}`} 
            />
            {isInvalidDate && (
              <div className="state-error">
              <img src={Alert} alt="state-error" width={"16px"} height={"15px"}/>
              <p className="state-error-text">Invalid date of birth. Please enter a valid date.</p>
            </div>
            )}
            {!isInvalidDate && !isValidAge && dob.length === 10 && (
               <div className="state-error">
               <img src={Alert} alt="state-error" width={"16px"} height={"15px"}/>
               <p className="state-error-text">You must be between 18 and 74 years old to continue.</p>
             </div>
            )}
          </div>
          <button
                className="next-btn sticky-btn"
                onClick={handleNext}
                disabled={dob.length !== 10 || isInvalidDate || !isValidAge}
              >
                Next →
              </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default SignupPage5;
